import { Container } from '@material-ui/core';
import { compose } from 'ramda';
import { withTranslation } from 'react-i18next';
import CheckoutContainer from './containers/CheckoutContainer';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  checkoutContainer: {
    backgroundColor: theme.palette.background.default,
    minHeight: '500px',
    padding: 0,
    maxWidth: '591px',
    [theme.breakpoints.down('lg')]: {
      maxWidth: '531px',
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: '435px',
    },
  },
}));

function Checkout(props) {
  const classes = useStyles();
  return (
    <Container className={classes.checkoutContainer}>
      <CheckoutContainer {...props} />
    </Container>
  );
}

export default compose(withTranslation())(Checkout);
